import { render, staticRenderFns } from "./ItemTransferModal.vue?vue&type=template&id=bdc754b4&scoped=true"
import script from "./ItemTransferModal.vue?vue&type=script&lang=js"
export * from "./ItemTransferModal.vue?vue&type=script&lang=js"
import style0 from "./ItemTransferModal.vue?vue&type=style&index=0&id=bdc754b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc754b4",
  null
  
)

export default component.exports